import { breakPoint } from '@coursera/coursera-ui';

export const BASE_STYLES = {
  containerWrapper: {
    padding: '0 24px',
    [`@media (max-width: ${breakPoint.md - 1}px)`]: {
      padding: '0 16px',
    },
  },
  container: {
    maxWidth: '1152px',
    paddingLeft: '0px !important', // CUI override to remove extra padding on Container
    paddingRight: '0px !important', // CUI override to remove extra padding on Container
  },
  title: {
    textAlign: 'center',
  },
  titleMobile: {
    // sadly, @media doesn't add any specificity, so we need to use !important
    fontSize: '24px !important',
    lineHeight: '30px !important',
  },
};
